import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const consultarProcedimientosPssUrl =
  "api/v1/websalud/primeraars/prestadores/yo/procedimientos";

const getMedicosUrl = "api/v1/websalud/primeraars/prestadores/medicos";

const validarPaqueteUrl =
  "api/v1/websalud/primeraars/prestadores/yo/pss/paquete/validacion";

const validarNivelAtencionUrl =
  "api/v1/websalud/primeraars/prestadores/niveles";

const consultarProcedimientosPss = (request) =>
  InterceptToken(BaseApi.get, consultarProcedimientosPssUrl, request).then(
    (response) => response.data
  );

const getMedicos = (request) =>
  InterceptToken(BaseApi.get, getMedicosUrl, request).then(
    (response) => response.data
  );

const validarPaquete = (request) =>
  InterceptToken(BaseApi.get, validarPaqueteUrl, request).then(
    (response) => response.data
  );

const validarNivelAtencion = (request) =>
  InterceptToken(BaseApi.get, validarNivelAtencionUrl, request).then(
    (response) => response.data
  );

const actualizarPrestadorStandVirtual = (request) => {
  const { codigoPss, tipoPss, standVirtualHabilitado } = request;
  return InterceptToken(
    BaseApi.put,
    `api/v1/websalud/primeraars/prestadores/${tipoPss}/${codigoPss}/stand-virtual`,
    standVirtualHabilitado
  ).then((response) => response.data);
};

const exportedObject = {
  consultarProcedimientosPss,
  getMedicos,
  validarPaquete,
  validarNivelAtencion,
  actualizarPrestadorStandVirtual
};

export default exportedObject;
